import { SelectType } from "./SelectType"
import { Installments } from "./Installments"
import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext"
import { SelectValues } from "./SelectValues"
import { Documents } from "./documents"
import { CreditPartner } from "../../useCreditController"

interface PartnerSimulationProps {
  partners: CreditPartner[],
  onNext: () => void
}
export const PartnerSimulation = ({ partners, onNext }: PartnerSimulationProps) => {
  const { step2mode } = useSelfHiringContext()

  const steps = {
    partner: <SelectType partners={partners} />,
    installments: <div className="max-w-lg mx-auto"><Installments onNext={onNext} /></div>,
    selectValues: <div className="max-w-lg mx-auto"><SelectValues /></div>,
    documents: <div className="max-w-lg mx-auto"><Documents /></div>,
  }

  return (
    <>
      {steps[step2mode as keyof typeof steps]}
    </>
  )
}